import { ErrorCode } from '@supabase/auth-js/src/lib/error-codes';

export const getAuthError = (code: ErrorCode) => {
    switch (code) {
        case 'email_address_invalid':
            return 'This account does not exist - register or contact support';
        case 'email_address_not_authorized':
            return 'This email has not been verified';
        case 'invalid_credentials':
            return 'Incorrect email or password';
        case 'request_timeout':
            return 'Request took to long, try again';
        case 'email_exists':
            return 'An account associated with this email already exists';
        default:
            return 'Something went wrong, try again';
    }
};
